// extracted by mini-css-extract-plugin
module.exports = {"table-date-and-user-wrapper":"TableDateAndUser_table-date-and-user-wrapper__a8hpF"};